import { SidebarMenuButton } from "@/components/ui/sidebar";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { AREA_LABELS } from "@/lib/permissions";
import { cn } from "@/lib/utils";
import type { DashboardRoute } from "@/routes";
import { routeUrl } from "@/routes";
import { IconLock, type Icon } from "@tabler/icons-react";
import { Link } from "react-router";

export interface NavItem {
  title: string;
  url: string;
  icon?: Icon;
  locked: boolean;
  area: DashboardRoute["area"];
}

export const toNavItem = (
  route: DashboardRoute,
  locked: boolean,
): NavItem => ({
  title: route.title,
  url: routeUrl(route),
  icon: route.icon,
  locked,
  area: route.area,
});

export function NavItemButton({
  item,
  isActive,
}: {
  item: NavItem;
  isActive: boolean;
}) {
  if (!item.locked) {
    return (
      <SidebarMenuButton tooltip={item.title} asChild isActive={isActive}>
        <Link to={item.url}>
          {item.icon && <item.icon />}
          <span>{item.title}</span>
        </Link>
      </SidebarMenuButton>
    );
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* Kept visible but inert, so people can see what exists to ask for. */}
        <SidebarMenuButton
          aria-disabled
          className={cn(
            "cursor-not-allowed opacity-40",
            "hover:bg-transparent hover:text-sidebar-foreground active:bg-transparent",
          )}
          onClick={(e) => e.preventDefault()}
        >
          {item.icon && <item.icon />}
          <span className="min-w-0 truncate">{item.title}</span>
          <IconLock className="ml-auto size-3.5 shrink-0" />
        </SidebarMenuButton>
      </TooltipTrigger>
      <TooltipContent side="right">
        No access{item.area ? ` — needs ${AREA_LABELS[item.area]}` : ""}
      </TooltipContent>
    </Tooltip>
  );
}
